import React from "react";
import {createRoot} from "react-dom/client";
import CartHeader from "./component/CartHeader";

export default () => {
    const dom = document.querySelector('[data-cart-header]');
    if (dom) {
        const root = createRoot(dom);
        root.render(<CartHeader
            editable={parseInt(dom.getAttribute('data-can-edit')) === 1}
            sample_order={parseInt(dom.getAttribute('data-is-sample-order')) === 1}
        />);
    }
}
